<template>
  <transition leave-active-class="duration-200">
    <div
      class="z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center"
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          class="fixed inset-0 transition-opacity"
          @click="closePopup()"
        >
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- Content modal -->
      <div
        class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full sm:p-6"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div
          class="cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
          @click="closePopup()"
        >
          <icon name="close" />
        </div>

        <!-- CONTENT HERE -->
        <form class="my-10 mx-4 lg:mx-0">
          <MessageHeader :message-header="messageHeader" />

          <!-- --------------- BEGIN Page Contact --------------- -->

          <h2 class="text-3xl text-gray-900 mt-20 mb-10 font-normal uppercase">
            Contact
          </h2>

          <div class="text-center text-lg text-indigo-600">
            <p
              class="mb-10"
              v-if="$subscribed()"
            >
              Veuillez nous contacter par téléphone afin obtenir un devis
              personnalisé.
            </p>

            <a
              v-if="$subscribed()"
              :href="hrefTel"
              class="text-pink-600"
            >{{ tel }}</a>

            <p
              v-if="$subscribed()"
              class="mt-10"
            >
              Ou via le formulaire de contact ci-dessous.
            </p>
            <p v-else>
              Veuillez nous contacter via le formulaire de contact ci-dessous afin d'obtenir un devis
              personnalisé.
            </p>
          </div>

          <div class="my-10 w-full">
            <div class="grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/5 2xl:mx-1/4">
              <input-text
                class="lg:col-span-6"
                required="required"
                type="number"
                libelle="Nombre de carnets de parcours souhaités"
                v-model="form.neopass"
                :min="10"
                :error="true"
                :msg-error="(errors.neopass || [])[0] || ''"
                @focusInput="(errors.neopass || [])[0] = ''"
              />
              <input-text
                class="lg:col-span-6"
                type="tel"
                :error="true"
                required="required"
                name="phone_number"
                libelle="Téléphone"
                v-model="form.phone_number"
                :msg-error="(errors.phone_number || [])[0] || ''"
                @focusInput="(errors.phone_number || [])[0] = ''"
              />
              <input-text-area
                class="lg:col-span-full"
                size="5"
                name="message"
                libelle="Message"
                :value="form.message"
                @input="
                  (newValue) => {
                    form.message = newValue;
                  }
                "
                :required="true"
                :error="true"
                :msg-error="(errors.message || [])[0] || ''"
                @focusInput="(errors.message || [])[0] = ''"
              />

              <div class="flex justify-end w-full lg:col-span-full">
                <action-button
                  class="mt-10"
                  border-color="border-transparent"
                  text-color="text-white"
                  bg-color="bg-pink-600"
                  bg-color-square="bg-pink-600"
                  icon-color="text-white"
                  libelle="Envoyer"
                  :uppercase="true"
                  icon="plane"
                  :responsive="true"
                  type-shadow="shadow-pink"
                  :right="true"
                  :spinner="sending"
                  @clickAction="sendForm"
                />
              </div>
            </div>
          </div>
          <!-- --------------- END Page Contact --------------- -->
        </form>
      </div>
      <!-- END Content modal -->
    </div>
  </transition>
</template>

<script>
import Icon from './Icon';
import ActionButton from './ActionButton';
import InputText from './Inputs/InputText';
import InputTextArea from './Inputs/InputTextArea';
import store from '../store';
import axios from '../api';
import MessageHeader from './MessageHeader';
import {mapGetters, mapState} from 'vuex';

export default {
  components: {
    MessageHeader,
    InputTextArea,
    InputText,
    ActionButton,
    Icon,
  },

  name: 'PopupContactOffer',

  data() {
    return {
      errors: {
        phone_number: [],
        message: [],
        neopass: [],
      },
      tel: '06 33 01 76 16',
      sending: false,
      form: {
        username: '',
        firstname: '',
        lastname: '',
        email: '',
        phone_number: '',
        company: '',
        function: '',
        message: '',
        neopass: null,
        choice: undefined,
      },
      messageHeader: null,
    };
  },

  computed: {
    hrefTel() {
      return `tel:${this.tel}`;
    },

    ...mapGetters({
      user: 'auth/user'
    }),
    ...mapState('account', ['showContactOfferPopup'])
  },

  created() {
    this.initForm();
  },

  methods: {
    closePopup() {
      this.$emit('close');
    },
    initForm() {
      const user = store.getters['auth/user'];
      this.$store.commit('account/SET_MESSAGEHEADER', null);

      this.form.username = user.username;
      this.form.firstname = user.firstname;
      this.form.lastname = user.lastname;
      this.form.email = user.email;
      this.form.phone_number = user.phone_number;
      this.form.message = '';
      this.form.neopass = null;
      this.form.choice = this.showContactOfferPopup;

      axios.get('/api/users/company/' + user.id).then((response) => {
        this.form.company = response.data.name;
      });
    },
    async sendForm() {
      if (!this.form.phone_number || this.form.phone_number === '') {
        this.errors.phone_number.push(
          'Veuillez renseigner un numéro de téléphone'
        );
        return;
      }

      if (
        !/^\d+$/.test(this.form.phone_number.replaceAll(/\s/g, '')) ||
        this.form.phone_number.replaceAll(/\s/g, '').length != 10
      ) {
        this.errors.phone_number.push(
          'Le numéro de téléphone n\'est pas au bon format'
        );
        return;
      }

      this.sending = true;
      this.headerMessage = null;
      this.$store.commit('account/SET_MESSAGEHEADER', null);

      try {
        const { data } = await axios.post('/api/contact/offer', this.form);

        if (data.sent) {
          this.initForm();
          this.closePopup();

          this.$store.commit('account/SET_MESSAGEHEADER', {
            type: 'success',
            msg: 'Votre demande a bien été envoyée. Nous vous apporterons une réponse dès que possible.',
          });

          setTimeout(() => {
            this.$store.commit('account/SET_MESSAGEHEADER', null);
          }, 3000);
        }
      } catch (err) {
        const error = err.response ? err.response.data : err;

        this.errors = { ...this.errors, ...error.errors };

        this.messageHeader = {
          type: 'error',
          msg: `Impossible d'envoyer votre demande (${
            error.errors
              ? Object.values(error.errors).join(', ')
              : error.message
          }). Veuillez réessayer`,
        };
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
